import { galleryButtonAutomationTypeSuffix } from "..";

export const automationTypeWithGalleryButtonSuffix = (
  automationType?: string
) => {
  // Can we align with the "-suffix" notation that data-automation-id and id use?
  // Task 5498974: Align format of id + suffix notation for dataAutomationType
  return (
    automationType && `${automationType}${galleryButtonAutomationTypeSuffix}`
  );
};
